module.exports = __webpack_public_path__ + "static/img/cosco.d41009a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/cosco.png
// module id = iluM
// module chunks = 9